function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from 'react';
const SvgWorkflows = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16",
  className: props.className || ''
}, props), /*#__PURE__*/React.createElement("path", {
  stroke: props.color || 'currentColor',
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M7.098 2.87C5.065 2.654 1 3.346 1 7.86c0 4.515 4.21 4.729 6.316 4.271M5.23 9.668l2.707 2.62L4.95 15m6.97-11.942c0 1.136-.954 2.058-2.131 2.058-1.177 0-2.131-.922-2.131-2.058C7.658 1.92 8.612 1 9.788 1c1.178 0 2.132.921 2.132 2.058Zm-.871 11.599h2.955c.55 0 .996-.447.996-.998v-2.681a.997.997 0 0 0-.996-.998H11.05a.997.997 0 0 0-.996.998v2.681c0 .551.446.998.996.998Z"
}));
export default SvgWorkflows;